// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3EEIN","upload":"Small_upload__25y4Z","imageWrap":"Small_imageWrap__1HkSy","removeBtn":"Small_removeBtn__3iXWt"};